import React, { useState } from 'react';
import { AppService } from '@aperza/util';
import { HeaderMenuIconButton } from './menulist/HeaderMenuIconButton';
import style from './menulist/HeaderMenuButton.module.scss';
import { useAperzaUserContext } from './AperzaUserContext';
import { addUtmParam } from '../addUtmParam';
export default function AccountCartButton() {
    const { user, serviceType } = useAperzaUserContext();
    const [isActive, setIsActive] = useState(false);
    return (React.createElement("div", null,
        React.createElement("button", { type: "button", className: style.button, onClick: () => {
                window.location.href = addUtmParam(`${AppService.orderServerHost()}/cart`, 'header', serviceType);
            }, style: { width: 44 }, onMouseEnter: () => !isActive && setIsActive(true), onMouseLeave: () => isActive && setIsActive(false) },
            React.createElement(HeaderMenuIconButton, { label: "\u30AB\u30FC\u30C8", icon: user?.cartBadge?.totalPurchaseNumber && user?.cartBadge?.totalPurchaseNumber > 0
                    ? `${AppService.staticServerHost()}/common/images/header/cart_dot.svg`
                    : `${AppService.staticServerHost()}/common/images/header/cart.svg`, iconHover: user?.cartBadge?.totalPurchaseNumber && user?.cartBadge?.totalPurchaseNumber > 0
                    ? `${AppService.staticServerHost()}/common/images/header/cart_red_dot.svg`
                    : `${AppService.staticServerHost()}/common/images/header/cart_red.svg`, isActive: isActive }))));
}
